import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";

import PaginationButtons from "../../../commons/components/pagination/PaginationButtons";
import { ROUTES } from "../../../commons/constants/routes/routes";
import { getUpdatedSearchParam } from "../../../commons/services/Router";

class NoticeMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      filteredItems: [],
      pageItems: [],
      totalCount: 0,
      currentPage: null,
      totalPageCount: 0,
      maxItemsPerPage: 10,
      keyword: "",
    };
    this.getItems = this.getItems.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.updatePageParam = this.updatePageParam.bind(this);
  }

  async componentDidMount() {
    this.initPaginationSearchParam();
    await this.getItems();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPage !== this.state.currentPage) {
      this.setPagination();
    }
    if (prevProps.location.search !== this.props.location.search) {
      const page = this.getPageSearchParam();
      if (page) this.setState({ currentPage: Number(page) }, this.setPagination);
    }
  }

  getPageSearchParam() {
    return new URLSearchParams(this.props.location.search).get("page");
  }

  initPaginationSearchParam() {
    const page = this.getPageSearchParam() || 1;
    this.setState({ currentPage: Number(page) });
  }

  updatePageParam(page) {
    const updatedParams = getUpdatedSearchParam({ page }, this.props.location);
    this.props.history.push({ pathname: this.props.location.pathname, search: updatedParams });
  }

  setPagination() {
    const { filteredItems, currentPage } = this.state;
    const pageList = [];
    filteredItems.forEach((item, index) => {
      if (index % 10 === 0) pageList.push([...filteredItems.slice(index, index + 10)]);
    });
    this.setState({ pageItems: pageList[currentPage - 1] || [] });
  }

  async getItems() {
    try {
      const res = await axios.get("/cst/api/notice");
      const items = res.data.data || [];
      this.setState({ items, totalCount: items.length }, this.handleSearch);
    } catch (e) {
      console.log(e);
    }
  }

  handleSearch(e) {
    if (e) e.preventDefault();
    const { items, keyword } = this.state;

    let filtered = keyword
      ? items.filter((item) => item.title && item.title.includes(keyword))
      : [...items];

    this.setState(
      {
        filteredItems: filtered,
        totalPageCount: Math.ceil(filtered.length / this.state.maxItemsPerPage),
      },
      this.setPagination
    );
  }

  render() {
    const { keyword, filteredItems, pageItems } = this.state;

    return (
      <Wrap>
        <div className="page-tit gray">
          <div className="container f-stack">
            <h2 className="tit">공지사항</h2>
            <Link to={ROUTES.NOTICE.CREATE} className="btn secondary">
              공지 등록
            </Link>
          </div>
        </div>
        <div className="container">
          <div className="top-search">
            <p className="all">
              공지 목록<span> 총 {this.state.totalCount}건</span>
            </p>
            <div className="search">
              <form onSubmit={this.handleSearch}>
                <div className="input-search">
                  <input
                    type="text"
                    id="keyword"
                    placeholder="제목을 입력하세요"
                    value={keyword}
                    onChange={(e) => this.setState({ keyword: e.target.value })}
                  />
                  <button type="submit" className="material-icons">
                    search
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="h-table">
              <colgroup>
                <col style={{ width: "6%" }} />
                <col style={{ width: "64%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "5%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>제목</th>
                  <th>등록일</th>
                  <th>수정일</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {pageItems.length > 0 ? (
                  pageItems.map((row, index) => (
                    <tr key={row.id}>
                      <td>
                        {this.state.totalCount - ((this.state.currentPage - 1) * 10 + index)}
                      </td>
                      <td className="ellipsis left" title={row.title}>{row.title}</td>
                      <td>{row.createDt}</td>
                      <td>{row.updateDt}</td>
                      <td>
                        <Link
                          className="detail-link link-btn"
                          to={ROUTES.NOTICE.DETAIL(row.id)}
                        >
                          상세
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">등록된 공지사항이 없습니다.</td>
                  </tr>
                )}
              </tbody>
            </table>
            {filteredItems.length > 10 && (
              <PaginationButtons
                totalPageCount={this.state.totalPageCount}
                currentPage={this.state.currentPage}
                onChangePage={this.updatePageParam}
              />
            )}
          </div>
        </div>
      </Wrap>
    );
  }
}

const Wrap = styled.div`
  .page-tit .btn {
    width: 168px;
    border-radius: 8px;
  }
  .top-search .all {
    font-size: 15px;
    font-weight: bold;
    color: #191919;
    span {
      font-weight: normal;
      color: #888e98;
      display: inline-block;
      margin-left: 10px;
    }
  }
  .search form {
    select {
      border: 1px solid #d5d8de;
      margin-right: 12px;
    }
  }
  .ellipsis {
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .left {
    text-align: left;
    padding-left: 12px;
  }
  .link-btn {
    display: inline-block;
    font-size: 12px;
    width: 45px;
    padding: 3px 0;
    text-align: center;
    border-radius: 5px;
    text-decoration: none;
  }
  .detail-link {
    background-color: var(--secondary-500);
    border: 1px solid var(--secondary-500);
    color: #fff;
    &:hover {
      background-color: var(--secondary-600);
    }
  }
`;

export default withRouter(NoticeMain);
